import { Box, Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { ShippingAddress } from "../api/paymentApi";
import { SealCheckIcon } from "../../icons/SealCheckIcon";
import { PurchaseButton } from "./PurchaseButton";
import { COUNTRIES } from "../constants";

interface ConfirmationStepProps {
  address: ShippingAddress;
  onClose: () => void;
  releaseTitle?: string;
}

export function ConfirmationStep({
  address,
  onClose,
  releaseTitle,
}: ConfirmationStepProps) {
  return (
    <Flex
      flexDirection="column"
      gap="12px"
      width="100%"
      alignItems="center"
      textAlign="center"
      position="relative"
    >
      <SealCheckIcon color="success.500" boxSize="80px" />
      <Text fontWeight="700" fontSize="24px">
        {t("components.payments.pod.purchaseComplete")}
      </Text>
      {releaseTitle && (
        <Box gap="4px">
          <Text fontSize="16px" fontWeight="600" color="dune.600">
            {t("components.payments.pod.physicalEditionOf")}:
          </Text>
          <Text fontSize="16px" fontWeight="600" color="white">
            {releaseTitle}
          </Text>
        </Box>
      )}
      <Text fontSize="12px" color="dune.400" mb="8px">
        {t("components.payments.pod.yourOrderHasBeenPlaced")}
        <br />
        {t("components.payments.pod.youWillReceiveAnEmailConfirmationShortly")}
      </Text>
      <Box
        bg="transparent.white.10"
        borderRadius="16px"
        p="16px"
        width="100%"
        mb="16px"
      >
        <Text fontSize="18px" fontWeight="700" mb="8px">
          {t("components.payments.pod.shippingTo")}
        </Text>
        <Text fontSize="14px" color="dune.400">
          {address.first_name} {address.last_name}
          <br />
          {address.address_line1}
          {address.address_line2 && (
            <>
              <br />
              {address.address_line2}
            </>
          )}
          <br />
          {address.city}
          {address.state && `, ${address.state}`} {address.zip}
          <br />
          {COUNTRIES.find((c) => c.id === address.country_id)?.name ||
            address.country_id.toUpperCase()}
        </Text>
      </Box>
      <PurchaseButton
        text={t("components.payments.pod.done")}
        onClick={onClose}
      />
      <DotLottieReact
        src={`${window.gc.global.assets_url}/static/images/web-ui/stars_confetti.json`}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
        autoplay
      />
    </Flex>
  );
}
